import {yupResolver} from "@hookform/resolvers/yup/dist/yup";
import {useForm} from "react-hook-form";
import {Button} from "../components/nuclear/button";
import {Input} from "../components/nuclear/input";
import {Label} from "../components/nuclear/label";
import "./UserNameInput.module.css";
import "./authentication/AuthenticationLayout.module.css";
import useUserNameInputModel from "../models/account/useUserNameInputModel";

export function UserNameInput() {
    const {validationSchema, handleSubmitUsername} = useUserNameInputModel();

    const {
        register,
        handleSubmit,
        formState: {errors, isSubmitting},
    } = useForm({
        resolver: yupResolver(validationSchema),
    });

    const usernameField = register("username");

    return (
        <section className={"username-page-shell"}>
            <div className={"username-page-card"}>
                <h1 className={"username-page-title"}>
                    Enter your username for your new account
                </h1>
                <form
                    className={"auth-form-grid"}
                    noValidate={true}
                    onSubmit={handleSubmit(handleSubmitUsername)}
                >
                    <div>
                        <Label htmlFor={"username"} className={"auth-field-label"}>
                            Select your username
                        </Label>
                        <Input
                            {...usernameField}
                            id={"username"}
                            aria-invalid={errors.username ? "true" : "false"}
                            aria-describedby={errors.username ? "username-error" : undefined}
                        />
                    </div>
                    {errors.username ? (
                        <p id={"username-error"} role={"alert"} className={"auth-panel-error"}>
                            {errors.username.message}
                        </p>
                    ) : null}
                    <Button
                        type={"submit"}
                        disabled={isSubmitting}
                        aria-busy={isSubmitting ? "true" : "false"}
                        fullWidth={true}
                    >
                        Save
                    </Button>
                </form>
            </div>
        </section>
    );
}
